import React, { useEffect, useState } from "react";
import "./TimeSheets.css";

function isRenderablePhotoUrl(url) {
  if (url == null) return false;
  const u = String(url).trim();
  if (!u) return false;
  return u.startsWith("http://") || u.startsWith("https://") || u.startsWith("/") || u.startsWith("data:");
}

function getLeadInitial(name) {
  const s = String(name || "").trim();
  for (let i = 0; i < s.length; i += 1) {
    const ch = s[i];
    if (/[a-zA-Z]/.test(ch)) return ch.toUpperCase();
  }
  return s ? s[0].toUpperCase() : "?";
}

/**
 * Avatar + name + designation + email for timesheet grids.
 * @param {{ name: string, designation?: string, email?: string, photoUrl?: string, variant?: 'default' | 'approval' }} props
 */
const TimeSheetPersonCell = ({ name, designation = "", email = "", photoUrl, variant = "default" }) => {
  const isApproval = variant === "approval";
  const fallbackAvatarSrc = `https://ui-avatars.com/api/?name=${encodeURIComponent(name || "User")}&background=0f62fe&color=fff&size=128`;

  const usePhoto = isApproval ? isRenderablePhotoUrl(photoUrl) : true;
  const [imgBroken, setImgBroken] = useState(false);

  useEffect(() => {
    setImgBroken(false);
  }, [photoUrl, variant]);

  const imageSrc =
    isApproval && usePhoto
      ? String(photoUrl).trim()
      : !isApproval
        ? photoUrl || fallbackAvatarSrc
        : fallbackAvatarSrc;

  const showInitialsFallback = isApproval && (!usePhoto || imgBroken);

  return (
    <div className={`ts-person-cell ${isApproval ? "ts-person-cell--approval" : ""}`}>
      <div className="ts-person-avatar-wrap">
        {showInitialsFallback ? (
          <span className="ts-person-avatar-fallback" aria-hidden>
            {getLeadInitial(name)}
          </span>
        ) : (
          <img
            className={`ts-person-avatar ${isApproval ? "ts-person-avatar--circle" : ""}`}
            src={imageSrc}
            alt=""
            width={40}
            height={40}
            loading="lazy"
            onError={() => {
              if (isApproval) setImgBroken(true);
            }}
          />
        )}
      </div>
      <div className="ts-person-meta">
        {isApproval ? (
          <>
            <div className="ts-person-name">{name}</div>
            {email ? (
              <a className="ts-person-email" href={`mailto:${email}`}>
                {email}
              </a>
            ) : null}
            {designation ? <div className="ts-person-designation ts-person-designation--below-email">{designation}</div> : null}
          </>
        ) : (
          <>
            <div className="ts-person-name">{name}</div>
            {designation ? <div className="ts-person-designation">{designation}</div> : null}
            {email ? (
              <a className="ts-person-email" href={`mailto:${email}`}>
                {email}
              </a>
            ) : null}
          </>
        )}
      </div>
    </div>
  );
};

export default TimeSheetPersonCell;
